// pageUtils.js

/**
 * Returns the current page's filename from the URL path
 * e.g. "/factory/art_factory.html" -> "art_factory.html"
 */
export function getCurrentPage() {
  return window.location.pathname.split('/').pop();
}

/**
 * Checks whether the current page matches any keyword in the given list.
 * @param {string[]} pageList - list of keywords to match against
 * @returns {boolean}
 */
export function isPageInList(pageList = []) {
  const page = getCurrentPage();
  return pageList.some((keyword) => page.includes(keyword));
}
export function isPageExact(pageList = []) {
  const page = getCurrentPage();
  return pageList.includes(page);
}
